import {SagaIterator} from 'redux-saga';
import {isActiveFilterByCode} from 'selectors/filters/filters';
import {sessionStore} from 'libs/storage/storage';

import {HTO_CODE_FILTER} from 'constants/category';
import {HTO_SESSION_STORAGE_TITLE} from 'constants/homeTryOn/homeTryOn';
import {CATEGORY} from 'constants/actions';

import {call, select, takeEvery} from 'redux-saga/effects';

/**
 * Check active filters for "eligible_for_hto" filter
 * and update hto mode variable in session storage
 */
export function* saveHtoFilterState() {
    const isActive = yield select(isActiveFilterByCode, HTO_CODE_FILTER);
    yield call([sessionStore, 'set'], HTO_SESSION_STORAGE_TITLE, isActive);
}

/**
 * Root saga
 */
export default function* homeTryOnCategorySaga(): SagaIterator {
    yield takeEvery(CATEGORY.SET_ACTIVE_FILTERS, saveHtoFilterState);
}
